export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-50 overflow-hidden flex flex-col lg:flex-row items-center">
          <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">移动观影</h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6">
              下载菲菲影院移动端APP，随时随地畅享高清电影。支持离线缓存、画质调节、
              夜间模式等专属功能，让观影不受时间和网络限制。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-white rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-line text-lg"></i>
                iOS 版本
              </span>
              <span className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-white rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-android-line text-lg"></i>
                Android 版本
              </span>
            </div>
            <p className="text-xs text-foreground-500 mt-4">即将支持离线缓存功能，敬请期待</p>
          </div>
          <div className="flex-1 w-full lg:max-w-xs p-6 md:p-8 flex justify-center">
            <div className="w-48 h-72 md:w-56 md:h-80 rounded-2xl overflow-hidden border-4 border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Movie%20streaming%20mobile%20app%20UI%20mockup%20with%20film%20posters%20grid%2C%20warm%20crimson%20and%20dark%20theme%2C%20modern%20minimal%20design%2C%20cinema%20app%20interface%2C%20clean%20layout%2C%20elegant%20dark%20mode&width=500&height=800&seq=app-mockup&orientation=portrait"
                alt="菲菲影院移动端APP界面"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}